module.exports = __webpack_public_path__ + "img/wifi.c9c9cb0a.png";